import React from "react";
export default function Social({ news, context }) {
    return <div className="constructor__soc text-right mobile-hide"></div>;
}
